import StudentNav from "./Navbars/StudentNav";
import AdminNav from "./Navbars/AdminNav";
import GuestNav from "./Navbars/GuestNav";
import TeacherNav from "./Navbars/TeacherNav";
import { Link } from "react-router-dom";
import "./Home.css";
import Testimonials from "./Testimonials";
import Offerings from "./Offerings";
import WhyChooseSection from "./WhyChooseSection";
import Footer from "../MyComponents/Footer";
import internshipImage from "../assets/kidandinstructor.png";
import googleButton from "../assets/google.png";
import countriesImage from "../assets/17countries.png";
import studentsImage from "../assets/10kstudent.png";
import homeboyImage from "../assets/homeboy.png";
import homegirlImage from "../assets/homegirl.png";
import bulbImage from "../assets/Bulb.png";
import sunImage from "../assets/sun.png";

const Home = () => {
  return (
    <>
      <GuestNav />

      <div className="home">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero__container">
            <div className="hero__content-wrapper">
              <div className="hero__background" style={{ backgroundColor: '#F0F0F0' }}>
                <img
                  src={homeboyImage}
                  alt="Boy illustration"
                  className="hero__boy-image"
                />
                <img
                  src={homegirlImage}
                  alt="Girl illustration"
                  className="hero__girl-image"
                />
                <img
                  src={bulbImage}
                  alt="Bulb illustration"
                  className="hero__bulb-image"
                />
                <img
                  src={sunImage}
                  alt="Sun illustration"
                  className="hero__sun-image"
                />
              </div>
              <div className="hero__content">
                <h1 className="hero__title">
                  <span className="purple-text">Empowering </span> <br></br>
                  <span className="pink-text">Young Minds</span> <br></br>
                  <span className="purple-text"> for a </span><br></br>
                  <span className="purple-text">Bright Future </span> <br></br> 
                  <br></br>
                 
                  
                </h1>
                <p className="hero__description">
                  At Polymath-Kids, we are a global Ed-Tech initiative dedicated to equipping children with essential 21st-century life skills. Our expertly designed online courses help kids develop cognitive, leadership, social, and problem-solving abilities, ensuring a strong foundation for academic success and future career readiness.
                </p>
                <div className="hero__stats">
                  <img
                    src={countriesImage}
                    alt="17 countries"
                    className="hero__countries-image"
                  />
                  <img
                    src={studentsImage}
                    alt="10k students"
                    className="hero__students-image"
                  />
                  <img
                    src={googleButton}
                    alt="Google rating"
                    className="hero__google-button"
                  />
                </div>
              </div>
            </div>

            {/* Register button positioned at the bottom of the hero section */}
            <div className="hero__register">
              <Link to="/sign-in">
                <img
                  src={require("../assets/ButtonRegister.png") || "/placeholder.svg"}
                  alt="Register Now"
                  className="register-button"
                />
              </Link>
            </div>
          </div>
        </section>

        {/* Offerings Section */}
        <Offerings />
        {/* Why Choose Us Section */}
        <WhyChooseSection />
        {/* Expert Teachers Section */}
        <section className="expert-teachers-section">
          <div className="container">
            <h2 className="expert-teachers-title">
              <span className="learn-from">Learn from&nbsp;</span>
              <span className="expert-teachers">Expert Teachers</span>
            </h2>
            <div className="expert-teachers-content">
              <div className="mainframe-instructor-wrapper">
                <img
                  src={require("../assets/mainframeinstructor.png")}
                  alt="Expert Teachers"
                  className="mainframe-instructor-img"
                />
              </div>
              <div className="teachers-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <img
                      src={require("../assets/hat.png")}
                      alt="Certified Instructors"
                    />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">500+</h3>
                    <p className="stat-text">Certified Instructors<br />Worldwide</p>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <img src={require("../assets/Bulb.png")} alt="Experience" />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">10+</h3>
                    <p className="stat-text">Years Of Teaching<br />Experience</p>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <img
                      src={require("../assets/femaleicon.png")}
                      alt="Female Teachers"
                    />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">91%</h3>
                    <p className="stat-text">Female Teachers</p>
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <img
                      src={require("../assets/bulbbook.png")}
                      alt="STEM Subjects"
                    />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">15+</h3>
                    <p className="stat-text">Coding & STEAM<br />Subjects</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Internship Section */}
        <section className="internship-section">
          <div className="container">
            <h2 className="internship-title">
              <span className="internship-main">Internship Opportunities</span><br /><br />
              <span className="internship-brand">at Polymath-Kids</span>
            </h2>
            <div className="internship-content">
              <div className="internship-text">
                <p className="internship-description">
                  Join Polymath-Kids for hands-on experience in the Ed-Tech industry. Interns will collaborate with experts in course design, digital marketing, and STEM education, gaining valuable skills for future careers. We offer flexible remote and in-office internships.
                </p>
                <h3 className="internship-subtitle">Why Intern with Us?</h3>
                <ul className="internship-benefits">
                  <li>Work alongside industry experts</li>
                  <li>Gain real-world experience</li>
                  <li>Contribute to shaping the future of education</li>
                </ul>
              </div>
              <div className="internship-image">
                <img
                  src={internshipImage || "/placeholder.svg"}
                  alt="Intern working with student"
                />
              </div>
            </div>
          </div>
        </section>
        {/* Testimonials */}
        <Testimonials />
        {/* Gallery Section */}
        <section className="gallery-section">
          <div className="container">
            <div className="gallery-header">
              <h2 className="gallery-title" style={{marginTop: '2em', marginBottom: '2em'}}>
                <span className="gallery-of">Gallery of </span>
                <span className="learning-growth">Learning & Growth</span>
              </h2>
              <div className="sun-icon">
                <img src={require("../assets/sun.png")} alt="Sun" />
              </div>
            </div>
            <div className="gallery-grid">
              {[...Array(8)].map((_, i) => (
                <div className="gallery-item" key={i}>
                  <img
                    src={require(`../assets/kid${i + 7}.png`) || "/placeholder.svg"}
                    alt="Learning child"
                  />
                </div>
              ))}
            </div>
            <div className="calculator-icon">
              <img src={require("../assets/calculator.png")} alt="Calculator" />
            </div>
            <div className="gallery-button">
              <Link to="/gallery">
                <img src={require("../assets/viewgallery.png")} alt="View Gallery" />
              </Link>
            </div>
          </div>
        </section>
        {/* Featured Blog Posts Section */}
        <section className="featured-blogs-section">
          <div className="container">
            <h2 className="featured-blogs-title">
              <span className="featured-blog">Featured Blog</span>{" "}
              <span className="featured-posts">Posts</span>
            </h2>
            <div className="blog-posts-grid">
              <div className="blog-post-card">
                <div className="blog-post-image">
                  <img
                    src={require("../assets/kid15.png") || "/placeholder.svg"}
                    alt="Child with book"
                  />
                </div>
                <div className="blog-post-content">
                  <div className="blog-post-date">3 April 2025</div>
                  <h3 className="blog-post-title">
                    The Importance of 21st-Century Skills for Kids
                  </h3>
                  <p className="blog-post-excerpt">
                    As the world continues to evolve, so do the skills necessary to succeed in the modern workforce. At Polymath-Kids, we focus on...
                  </p>
                </div>
              </div>
              <div className="blog-post-card">
                <div className="blog-post-image">
                  <img
                    src={require("../assets/kid16.png") || "/placeholder.svg"}
                    alt="Child coding"
                  />
                </div>
                <div className="blog-post-content">
                  <div className="blog-post-date">3 April 2025</div>
                  <h3 className="blog-post-title">
                    How Coding Enhances Problem-Solving in Kids
                  </h3>
                  <p className="blog-post-excerpt">
                    Learning to code does more than just teach a child how to build websites or apps. It fosters problem-solving skills...
                  </p>
                </div>
              </div>
              <div className="blog-post-card">
                <div className="blog-post-image">
                  <img
                    src={require("../assets/kid17.png") || "/placeholder.svg"}
                    alt="Child with books"
                  />
                </div>
                <div className="blog-post-content">
                  <div className="blog-post-date">3 April 2025</div>
                  <h3 className="blog-post-title">
                    Success Stories: How Polymath-Kids Transformed Learning
                  </h3>
                  <p className="blog-post-excerpt">
                    At Polymath-Kids, we take pride in the success of our students. From mastering coding to learning how to...
                  </p>
                </div>
              </div>
            </div>
            <div className="view-all-blogs">
              <Link to="/blogs">
                <img
                  src={require("../assets/viewblog.png") || "/placeholder.svg"}
                  alt="View All Blogs"
                />
              </Link>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Home;